var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.652,
    x2: 452.378,
    y1: 298.133,
    y2: 503.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9b1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#814aa0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b3374",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b3374"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 444.64,
    y2: 496.645
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.091,
    x2: 274.224,
    xlinkHref: "#lg1",
    y1: 503.466,
    y2: 387.448
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bac8fa"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.624,
    x2: 173.893,
    xlinkHref: "#lg2",
    y1: 354.773,
    y2: 485.82
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.638,
    x2: 345.661,
    xlinkHref: "#lg2",
    y1: 368.951,
    y2: 477.668
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7b7f1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7b7f1"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.42,
    x2: 258.884,
    xlinkHref: "#lg3",
    y1: 522.386,
    y2: 388.988
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.923,
    x2: 296.325,
    xlinkHref: "#lg2",
    y1: 312.504,
    y2: 433.917
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.709,
    x2: 448.799,
    xlinkHref: "#lg2",
    y1: 312.118,
    y2: 428.826
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.105,
    x2: 411.05,
    xlinkHref: "#lg3",
    y1: 342.222,
    y2: 421.167
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.696,
    x2: 254.976,
    xlinkHref: "#lg3",
    y1: 235.985,
    y2: 453.96
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7b7f1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff5c6"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.581,
    x2: 217.914,
    xlinkHref: "#lg4",
    y1: 406.705,
    y2: 302.705
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.769,
    x2: 277.862,
    xlinkHref: "#lg4",
    y1: 410.231,
    y2: 304.324
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea613"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.905,
    x2: 338.446,
    xlinkHref: "#lg5",
    y1: 91.772,
    y2: 230.313
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.998,
    x2: 254.998,
    y1: 223.333,
    y2: 276.87
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7701",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1854,
    stopColor: "#f87204",
    stopOpacity: 0.185
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4314,
    stopColor: "#e7630c",
    stopOpacity: 0.431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    stopColor: "#cb4b19",
    stopOpacity: 0.711
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a72b2b"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 333.784,
    y2: 364.274
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4d2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 324.5,
    y2: 339.542
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 287.5,
    y2: 302.542
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 217,
    y2: 44.432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5c6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff5c6"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(0 1 -1 0 4853.736 -7922.238)",
    gradientUnits: "userSpaceOnUse",
    x1: 8025.106,
    x2: 8069.621,
    xlinkHref: "#lg5",
    y1: 4393.437,
    y2: 4393.437
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(.707 .707 -.707 .707 -754.412 -9504.19)",
    gradientUnits: "userSpaceOnUse",
    x1: 7587.968,
    x2: 7632.484,
    xlinkHref: "#lg5",
    y1: 5913.44,
    y2: 5913.44
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 7700.853 -2838.164)",
    gradientUnits: "userSpaceOnUse",
    x1: 7255.375,
    x2: 7299.891,
    xlinkHref: "#lg5",
    y1: 2999.037,
    y2: 2999.037
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(0 1 1 0 -3925.148 -7922.238)",
    gradientUnits: "userSpaceOnUse",
    x1: 8025.106,
    x2: 8069.621,
    xlinkHref: "#lg5",
    y1: 3974.849,
    y2: 3974.849
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(-.707 .707 .707 .707 1683 -9504.19)",
    gradientUnits: "userSpaceOnUse",
    x1: 7883.957,
    x2: 7928.473,
    xlinkHref: "#lg5",
    y1: 5617.451,
    y2: 5617.451
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(.707 .707 .707 -.707 -6772.265 -2838.164)",
    gradientUnits: "userSpaceOnUse",
    x1: 6959.386,
    x2: 7003.902,
    xlinkHref: "#lg5",
    y1: 2703.048,
    y2: 2703.048
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m430.308 265.586c-58.435-21.897-116.946-19.872-175.308 6.007v9.414c0-.369 0-3.507 0-9.414-58.417-25.904-116.928-27.883-175.309-6.007-8.85 3.316-14.684 11.819-14.684 21.269v208.337c0 8.508 8.457 14.479 16.446 11.551 52.814-19.356 105.733-19.188 158.59.551 9.655 3.605 20.262 3.605 29.917-.001 52.812-19.723 105.731-19.921 158.589-.549 7.988 2.928 16.445-3.044 16.445-11.552 0-67.842 0-140.495 0-208.337-.001-9.45-5.836-17.953-14.686-21.269z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.007 495.193c0 8.508 8.457 14.479 16.446 11.551 52.814-19.356 105.732-19.188 158.59.551 9.655 3.606 20.262 3.605 29.917-.001 52.812-19.723 105.73-19.921 158.589-.549 7.988 2.928 16.445-3.044 16.445-11.552 0-34.024 0-69.257 0-104.487h-379.988c0 35.23 0 70.463.001 104.487z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.99 286.853v208.34c0 8.51-8.45 14.48-16.44 11.55-52.86-19.37-105.78-19.17-158.59.55-9.66 3.61-20.26 3.61-29.92 0-45.11-16.84-90.27-19.43-135.37-7.79l-16.09-16.09v-220.95c55.43-18.48 110.96-15.46 166.42 9.13 58.36-25.88 116.87-27.9 175.31-6.01 8.85 3.32 14.68 11.82 14.68 21.27z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 450.425v40.548c-52.043-23.072-104.18-25.058-156.199-5.994-7.193 2.633-14.797-2.738-14.797-10.39v-40.548c0 7.651 7.604 13.022 14.797 10.39 52.019-19.063 104.156-17.077 156.199 5.994z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.996 434.042v40.548c0 7.651-7.604 13.034-14.797 10.39-52.066-19.075-104.203-17.065-156.199 5.994v-40.548c51.996-23.06 104.133-25.07 156.199-5.994 7.193 2.644 14.797-2.739 14.797-10.39z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m411.199 473.814c-52.066-19.075-104.203-17.066-156.199 5.994-52.043-23.072-104.18-25.058-156.199-5.994-7.193 2.633-14.797-2.738-14.797-10.39v11.165c0 7.651 7.604 13.022 14.797 10.39 52.019-19.064 104.156-17.077 156.199 5.994 51.996-23.06 104.133-25.069 156.199-5.994 7.193 2.644 14.797-2.738 14.797-10.39v-11.165c0 7.652-7.604 13.034-14.797 10.39z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m84 271.426v183.18c0 7.658 7.612 13.032 14.802 10.397 52.018-19.065 104.149-17.084 156.197 5.994.001-71.103.001-142.206.001-213.309-52.577-23.314-105.238-25.096-157.783-5.406-7.965 2.985-13.217 10.638-13.217 19.144z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 257.688v213.309c52-23.059 104.131-25.075 156.198-5.993 7.19 2.635 14.801-2.74 14.801-10.397 0-61.06 0-122.12 0-183.181 0-8.506-5.252-16.159-13.217-19.144-52.593-19.708-105.254-17.885-157.782 5.406z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.325 359.981c-10.94-3.167-21.883-5.401-32.829-6.705-5.773-.688-10.869 3.763-10.869 9.576v67.801c0 4.927 3.71 9.061 8.609 9.587 10.191 1.093 20.38 2.99 30.566 5.699 5.292 1.408 10.492-2.523 10.492-7.999v-69.984c0-3.686-2.427-6.949-5.969-7.975z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.131 365.403c23.914-6.364 47.847-8.28 71.779-5.75 4.896.518 9.158-3.324 9.158-8.247v-70.518c0-4.191-3.12-7.76-7.282-8.241-26.055-3.008-52.112-.746-78.144 6.788-3.546 1.026-5.982 4.288-5.982 7.979v69.984c-.001 5.468 5.187 9.411 10.471 8.005z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7bacdf"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m106.595 412.894c-3.028 0-5.846-1.928-6.835-4.964-1.23-3.776.832-7.836 4.608-9.067 42.185-13.752 84.968-14.086 127.162-.988 3.793 1.178 5.913 5.207 4.736 9.001-1.177 3.792-5.206 5.913-9 4.736-39.293-12.197-79.142-11.885-118.439.926-.742.241-1.494.356-2.232.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.595 442.938c-3.028 0-5.846-1.928-6.835-4.964-1.23-3.776.832-7.836 4.608-9.067 42.183-13.754 84.966-14.086 127.162-.988 3.793 1.178 5.913 5.207 4.736 9-1.177 3.792-5.206 5.913-9 4.736-39.296-12.199-79.144-11.886-118.439.926-.742.242-1.494.357-2.232.357z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m353.76 395.498v.009c0 3.988-3.243 7.178-7.231 7.192-20.047.07-40.094 3.349-60.003 9.837-.738.24-1.486.355-2.225.355-3.03 0-5.849-1.927-6.837-4.957-1.237-3.778.834-7.834 4.602-9.071 21.412-6.976 42.98-10.501 64.542-10.559 3.958-.011 7.152 3.238 7.152 7.194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.76 425.532c0 3.986-3.241 7.176-7.228 7.192-20.037.08-40.098 3.374-60.006 9.862-.738.24-1.486.355-2.225.355-3.03 0-5.849-1.927-6.837-4.967-1.237-3.778.834-7.834 4.602-9.071 21.394-6.967 42.975-10.499 64.539-10.566 3.959-.012 7.155 3.237 7.155 7.195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m284.3 352.167c-3.029 0-5.847-1.929-6.836-4.965-1.23-3.775.832-7.835 4.609-9.066 42.184-13.752 84.967-14.083 127.161-.988 3.793 1.178 5.913 5.207 4.736 9s-5.206 5.912-9 4.736c-39.292-12.196-79.141-11.884-118.44.926-.74.243-1.492.357-2.23.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.76 364.816v.009c0 3.988-3.243 7.178-7.231 7.192-20.047.07-40.094 3.349-60.003 9.837-.738.24-1.486.355-2.225.355-3.03 0-5.849-1.927-6.837-4.957-1.237-3.778.834-7.834 4.602-9.071 21.412-6.976 42.98-10.5 64.542-10.559 3.958-.012 7.152 3.237 7.152 7.194z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m284.3 291.441c-3.029 0-5.847-1.928-6.836-4.965-1.23-3.775.832-7.835 4.609-9.066 42.182-13.753 84.967-14.085 127.161-.988 3.793 1.178 5.913 5.207 4.736 9-1.177 3.792-5.202 5.911-9 4.736-39.293-12.197-79.142-11.886-118.44.926-.74.242-1.492.357-2.23.357z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.3 321.485c-3.029 0-5.847-1.928-6.836-4.965-1.23-3.775.832-7.835 4.609-9.066 28.918-9.427 58.273-12.585 87.262-9.382 3.947.436 6.793 3.991 6.358 7.938-.437 3.947-3.973 6.793-7.938 6.358-26.938-2.978-54.264-.031-81.224 8.76-.741.242-1.493.357-2.231.357z"
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "m84 271.426v183.18c0 7.658 7.612 13.032 14.802 10.397 52.018-19.065 104.149-17.084 156.197 5.994.001-71.103.001-142.206.001-213.309-52.577-23.314-105.238-25.096-157.783-5.406-7.965 2.985-13.217 10.638-13.217 19.144z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 257.688v213.309c52-23.059 104.131-25.075 156.198-5.993 7.19 2.635 14.801-2.74 14.801-10.397 0-61.06 0-122.12 0-183.181 0-8.506-5.252-16.159-13.217-19.144-52.593-19.708-105.254-17.885-157.782 5.406z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m382.391 127.391c0-70.356-57.034-127.39-127.39-127.391-70.203-.001-127.057 56.569-127.391 126.772-.18 37.752 16.065 71.71 42 95.149 19.78 17.876 30.89 43.417 30.89 70.078v.001h109c0-26.927 11.585-52.419 31.454-70.592 25.465-23.291 41.437-56.787 41.437-94.017z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.321 200c5.58 8.027 12.056 15.384 19.289 21.921 19.78 17.876 30.89 43.417 30.89 70.079h109c0-26.927 11.585-52.419 31.454-70.592 7.005-6.407 13.287-13.591 18.721-21.408z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 350,
    fill: "url(#SVGID_15_)",
    r: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.5 351h-91c-10.217 0-18.5-8.283-18.5-18.5 0-10.217 8.283-18.5 18.5-18.5h91c10.217 0 18.5 8.283 18.5 18.5 0 10.217-8.283 18.5-18.5 18.5z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.5 314h-91c-10.217 0-18.5-8.283-18.5-18.5 0-10.217 8.283-18.5 18.5-18.5h91c10.217 0 18.5 8.283 18.5 18.5 0 10.217-8.283 18.5-18.5 18.5z",
    fill: "url(#SVGID_17_)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 185.667,
    fill: "url(#SVGID_18_)",
    r: 77.576
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m427.607 117.23c0-8.852 7.176-16.028 16.028-16.028h33.329c8.852 0 16.028 7.176 16.028 16.028 0 8.852-7.176 16.028-16.028 16.028h-33.329c-8.852-.001-16.028-7.177-16.028-16.028z",
    fill: "url(#SVGID_19_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m416.686 75.928c-6.259-6.259-6.259-16.407 0-22.667l23.567-23.567c6.259-6.259 16.407-6.259 22.667 0 6.259 6.259 6.259 16.407 0 22.667l-23.567 23.567c-6.26 6.259-16.408 6.259-22.667 0z",
    fill: "url(#SVGID_20_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m416.686 158.531c6.259-6.259 16.407-6.259 22.667 0l23.567 23.567c6.259 6.259 6.259 16.407 0 22.667-6.259 6.259-16.407 6.259-22.667 0l-23.567-23.567c-6.259-6.259-6.259-16.408 0-22.667z",
    fill: "url(#SVGID_21_)"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.393 117.23c0-8.852-7.176-16.028-16.028-16.028h-33.329c-8.852 0-16.028 7.176-16.028 16.028 0 8.852 7.176 16.028 16.028 16.028h33.329c8.852-.001 16.028-7.177 16.028-16.028z",
    fill: "url(#SVGID_22_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m93.314 75.928c6.259-6.259 6.259-16.407 0-22.667l-23.567-23.567c-6.259-6.259-16.407-6.259-22.667 0-6.259 6.259-6.259 16.407 0 22.667l23.567 23.567c6.26 6.259 16.408 6.259 22.667 0z",
    fill: "url(#SVGID_23_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m93.314 158.531c-6.259-6.259-16.407-6.259-22.667 0l-23.567 23.567c-6.259 6.259-6.259 16.407 0 22.667 6.259 6.259 16.407 6.259 22.667 0l23.567-23.567c6.26-6.259 6.259-16.408 0-22.667z",
    fill: "url(#SVGID_24_)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.caa6e51f2fdda1ef03660eee270a8f4f.svg";
export { ForwardRef as ReactComponent };